import { render, staticRenderFns } from "./PageDesignerList.vue?vue&type=template&id=f446812a&scoped=true&"
import script from "./PageDesignerList.vue?vue&type=script&lang=js&"
export * from "./PageDesignerList.vue?vue&type=script&lang=js&"
import style0 from "./PageDesignerList.vue?vue&type=style&index=0&id=f446812a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f446812a",
  null
  
)

export default component.exports